import { render, staticRenderFns } from "./EntityInfo.vue?vue&type=template&id=32460c1d&scoped=true"
import script from "./EntityInfo.vue?vue&type=script&lang=ts"
export * from "./EntityInfo.vue?vue&type=script&lang=ts"
import style0 from "./EntityInfo.vue?vue&type=style&index=0&id=32460c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32460c1d",
  null
  
)

export default component.exports